var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tools01-abtest-detail"},[_c('el-row',[_c('el-col',[_c('h2',[_vm._v("ABテスト設定・編集")])])],1),_c('AbTestRegister',{attrs:{"toolId":_vm.toolId,"pageId":_vm.pageId,"testId":_vm.testId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }